import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore, isValidToken } from '../../stores/authStore';

/**
 * Route guard component
 * Protects routes that require authentication
 * Redirects to /login if no valid token is present
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const { token, isAuthenticated, user } = useAuthStore();

  // Check whether the user is authenticated and has a valid token
  const isAuthValid = isAuthenticated && isValidToken(token);

  if (!isAuthValid) {
    // 未认证时重定向到登录页，通过 query param 保留原始目标 URL
    const redirectTarget = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirectTarget}`} replace />;
  }

  // 已登录但没有任何项目时，统一进入入组页面
  const hasProjects = Boolean(user && user.projects && user.projects.length > 0);
  const isJoinPath = location.pathname.startsWith('/join-organization');
  if (user && !hasProjects && !isJoinPath) {
    return <Navigate to="/join-organization" replace />;
  }

  // Authenticated — render child routes
  return <Outlet />;
}
